export const MigrosAccountTheme = {
  name: 'Migros Account Theme',
  themeId: 'migrosaccount',
  fonts: {
    families: {
      text: '"Helvetica Neue", "Helvetica", arial, sans-serif',
      condensed: '"Helvetica Neue Condensed","Impact", arial, sans-serif',
      notes: '"MarketWeb", "Helvetica", arial, sans-serif',
      heading: '"Helvetica Neue", "Helvetica", arial, sans-serif',
      subHeading: '"Helvetica Neue", "Helvetica", arial, sans-serif',
      display: '"Helvetica Neue", "Helvetica", arial, sans-serif',
      articleText: '"Helvetica Neue", "Helvetica", arial, sans-serif',
      articleHeading: '"Helvetica Neue",  "Helvetica", arial, sans-serif'
    }
  }
};